import { defineMessages } from 'react-intl';

type MessageKeys = 'noOptionsMessage' | 'searchPlaceholder';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		noOptionsMessage: {
			id: 'paginated-picker.async-select.select.no-options-message.no-options-message',
			defaultMessage: 'No matches found',
			description: 'The text for when no matches are found in dropdown',
		},
		searchPlaceholder: {
			id: 'paginated-picker.async-select.select.search-placeholder',
			defaultMessage: 'Search',
			description: 'Placeholder text in search input indicating that the user can search',
		},
	});

export default message;
